import { VolunteerQueue } from '@/features/volunteers/ui/VolunteerQueue';

/**
 * §5: a page composes, it does not implement. The feature owns its own data fetching and
 * its own UI, so a second page can reuse the queue without inheriting this page's layout.
 */
export function VolunteersPage() {
  return <VolunteerQueue />;
}
